// eslint-disable-next-line max-len
// shadow: packages/gatsby-theme-times-modal-opened/src/gatsby-theme-pagebuilder/components/blocks/modal/times-modal-opened.js
import { useCallback } from 'react';

const useTimesModalOpened = () => {
  // make it a callback to prevent it from making the effect open it again
  const addTimesModalOpened = useCallback(() => null, []);
  return {
    modalAllowedToOpen: true,
    addTimesModalOpened,
  };
};

export default useTimesModalOpened;
